export default {
  DESKTOP: {
    NAME: 'desktop',
    WIDTH: 860,
    TITLE_RATIO: 1,
    WH_RATIO: 1,
  },
  TABLET: {
    NAME: 'tablet',
    WIDTH: 700,
    TITLE_RATIO: 0.72,
    WH_RATIO: 0.82,
  },
  MOBILE: {
    NAME: 'mobile',
    WIDTH: 375,
    TITLE_RATIO: 0.43,
    WH_RATIO: 0.44,
  },
};
